import { useTranslation } from 'react-i18next';
import ChatStyles from '../Chat.module.css';

const PageHeader = () => {
  const { t } = useTranslation();
  return (
    <div className={ChatStyles.convListHeader}>
      <div className={ChatStyles.convListTitleRow}>
        <span className={ChatStyles.convListTitle}>{t('screens.chat.messagesTitle')}</span>
        <span className={ChatStyles.encBadge}>
          <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5'>
            <rect x='3' y='11' width='18' height='11' rx='2' ry='2' />
            <path d='M7 11V7a5 5 0 0110 0v4' />
          </svg>
          {t('screens.chat.e2eBadgeFull')}
        </span>
      </div>
    </div>
  );
};

export default PageHeader;
